const configuredApiUrl = (process.env.REACT_APP_API_URL || "").trim();
const isLocalDevelopment = ["localhost", "127.0.0.1"].includes(
  window.location.hostname,
);
const isInsecureConfiguredUrl =
  configuredApiUrl.toLowerCase().startsWith("http://");

// Production is served over HTTPS and must use the same-origin Nginx proxy.
// This also protects against a stale CI/CD environment variable reintroducing
// a mixed-content request.
export const ApiUrl = {
  apiurl:
    isLocalDevelopment && configuredApiUrl && !isInsecureConfiguredUrl
      ? configuredApiUrl
      : isLocalDevelopment
        ? "http://127.0.0.1:8000/api/"
        : "/api/",
};
